import Vue from 'vue';
Vue.prototype.$storageURL = process.env.VUE_APP_AXIOS_BASE_URL + 'storage/';
